import { combineReducers } from 'redux';
import reportConfig from './reports_reducer';
import handlePoints from './handlePoints';

export default combineReducers({ reportConfig, handlePoints });
